import { render, staticRenderFns } from "./ArtworkPanel.vue?vue&type=template&id=c9e8a4fe&scoped=true&"
import script from "./ArtworkPanel.vue?vue&type=script&lang=js&"
export * from "./ArtworkPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkPanel.vue?vue&type=style&index=0&id=c9e8a4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e8a4fe",
  null
  
)

export default component.exports